import React from 'react';
import './ComingSoon.scss';

export default () => (
  <div className="ComingSoon">
    <h2>Coming Soon</h2>
  </div>
);
